module.exports = __webpack_public_path__ + "img/w3_percent_light.56815171.png";